import { render, staticRenderFns } from "./ZyroBackground.vue?vue&type=template&id=0d0c88b7&scoped=true&"
import script from "./ZyroBackground.vue?vue&type=script&lang=js&"
export * from "./ZyroBackground.vue?vue&type=script&lang=js&"
import style0 from "./ZyroBackground.vue?vue&type=style&index=0&id=0d0c88b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c88b7",
  null
  
)

export default component.exports